module.exports = __webpack_public_path__ + "img/icon_javascript.aac4650a.png";